import React from 'react';

import { hide_progress } from 'src/constants/extensions';
import { useStepContext } from 'src/contexts/stepContext/useStepContext';
import { useAppSelector } from 'src/store/reducers';
import { getProgressIndicatorOptionsValue } from 'src/util/extension';

import Stepper from '@helsenorge/designsystem-react/components/Stepper';

import { createPathForItem, useCheckIfEnabled } from '@helsenorge/refero';

import { shouldFormBeDisplayedAsStepView, getTopLevelItems } from './utils';

export const StepViewComponent = (): React.JSX.Element | null => {
  const isEnabled = useCheckIfEnabled();
  const { step } = useStepContext();
  const formDefinition = useAppSelector(state => state.refero.form.FormDefinition);
  const { isMicroweb, showStepperInMicroweb } = useAppSelector(state => state.microweb);

  const shouldRenderComponent = formDefinition && shouldFormBeDisplayedAsStepView(formDefinition);
  const visibleElements = getTopLevelItems(formDefinition)?.filter(topLevelElement => {
    return isEnabled(topLevelElement, createPathForItem(undefined, topLevelElement));
  });
  const progressIndicatorOptionValue = getProgressIndicatorOptionsValue(formDefinition?.Content);
  const hasHideStepperCoding = progressIndicatorOptionValue === hide_progress;
  const hideStepperInMicroweb = isMicroweb && showStepperInMicroweb === false;

  const hideStepper = !shouldRenderComponent || !visibleElements || hasHideStepperCoding || hideStepperInMicroweb;

  if (hideStepper) {
    return null;
  }
  return (
    <span className="page_refero__stepper-wrapper">
      <Stepper value={step} max={visibleElements.length - 1} testId="stepper" />
    </span>
  );
};
export default StepViewComponent;
